import { render } from "./AppealsDonationsPage.vue?vue&type=template&id=92336760&scoped=true"
import script from "./AppealsDonationsPage.vue?vue&type=script&lang=js"
export * from "./AppealsDonationsPage.vue?vue&type=script&lang=js"

import "./AppealsDonationsPage.vue?vue&type=style&index=0&id=92336760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92336760"]])

export default __exports__